module.exports = __webpack_public_path__ + "static/07-3a56079a70a246259b6e460f9481e147.jpg";